import { isNativeAndroid } from '@lemonade-hq/uniclient-mobile-bridge';
import { getPixelValue, spacing } from '@lemonade-hq/uniclient-theme';

export const MOBILE_HEADER_SAFE_AREA = window.mobileSettings?.safeAreaHeight ?? 0;
export const MOBILE_BOTTOM_SAFE_AREA =
  window.mobileSettings?.bottomSafeAreaHeight != null && window.mobileSettings.bottomSafeAreaHeight > 0
    ? window.mobileSettings.bottomSafeAreaHeight + (isNativeAndroid() ? getPixelValue(spacing.s12) : 0)
    : getPixelValue(spacing.s24);
